import React, { Component }  from 'react';
import { withRouter }        from 'react-router';
import { connect }           from 'react-redux';
import { Redirect }          from 'react-router-dom';
import TestBreadcrumb        from './Breadcrumb';
import RetrievePassword      from './User/RetrievePassword';
import TestInitiative        from './User/TestInitiative';
import Untouchables          from './Admin/Untouchables';
import ResetUser             from './Admin/ResetUser';
import { TestConstants }     from './environment';
import Required              from '../../Required';
import { isLoggedIn }        from '../../../utils/authService';
import { isInRoleFromToken } from '../../../utils/authService';
import { redirect }          from '../../../utils/authService'; 

class TestMaintenance extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | Test Maintenance';
  }

  render() {
    var path = this.props.location.pathname.toLowerCase();    
    if (!isLoggedIn()) {
      redirect(path.replace(/^\/|\/$/g, ''));
      return (
        <Required />
      );
    }
        
    let content = null;
    if (isInRoleFromToken(TestConstants.AdminRole)) {
      let component = null;
      if (path.endsWith(TestConstants.PathPrefix)) {
        component = <RetrievePassword />;
      }
      else if (path.startsWith(TestConstants.AdminPathPrefix + '/initiative')) {
        component = <TestInitiative />;
      }
      else if (path.startsWith(TestConstants.AdminPathPrefix + '/untouchables')) {
        component = <Untouchables />;
      }
      else if (path.startsWith(TestConstants.AdminPathPrefix + '/reset')) {
        component = <ResetUser />;
      }
      else if (path.startsWith(TestConstants.AdminPathPrefix)) {
        component = <RetrievePassword />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <TestBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else if (TestConstants.UserRole === "*" || isInRoleFromToken(TestConstants.UserRole)) {
      let component = null;
      if (path.endsWith(TestConstants.PathPrefix)) {
        component = <RetrievePassword />;
      }
      else if (path.startsWith(TestConstants.UserPathPrefix + '/initiative')) {
        component = <TestInitiative />;
      }
      else if (path.startsWith(TestConstants.UserPathPrefix + '/untouchables')) {
        component = <Untouchables />;
      }
      else if (path.startsWith(TestConstants.UserPathPrefix)) {
        component = <RetrievePassword />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <TestBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      return <Redirect to='/404' />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  
});

export default withRouter(connect(mapStateToProps)(TestMaintenance));
